import styles from './button.module.css';

function Button({ className = '', children, onClick, disabled, style, title = '' }) {
  return (
    <button disabled={disabled} style={style} className={`${className} ${styles.btnReset}`} title={title} onClick={onClick}>{children}</button>
  )
};

export default Button;